import { render, staticRenderFns } from "./LoanManagementList.vue?vue&type=template&id=166821a3&"
import script from "./LoanManagementList.vue?vue&type=script&lang=js&"
export * from "./LoanManagementList.vue?vue&type=script&lang=js&"
import style0 from "./LoanManagementList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports